export default {
  "hero.eyebrow": "USFans Spreadsheet Resource Center",
  "hero.title": "USFans Spreadsheet — Updated Resources, Guides & Tools",
  "hero.subtitle": "Find USFans spreadsheet resources, buying guides, seller information, shipping insights, QC tips, warehouse guides, reviews and safety information — organized in one easy-to-use resource hub.",
  "hero.ctaPrimary": "USFans Spreadsheet",
  "hero.ctaSecondary": "Buy It Now",
  "hero.ctaGuide": "Explore the Guide",
  "hero.trust": "Updated Resources · Practical Guides · Safety Information · Independent Resource",

  "categories.title": "Shop by Category",
  "categories.subtitle": "Jump straight to your favorite category on the main website.",
  "categories.dropdownLabel": "Browse categories",
  "categories.dropdownPlaceholder": "Select a category…",

  "featured.title": "The USFans Spreadsheet, Explained",
  "featured.body": "The USFans Spreadsheet brings popular product categories, updated links and useful buying information together in a single, organized view. Whether you are shopping for sneakers, looking for jerseys or comparing shipping options, the spreadsheet helps you move quickly from research to the right page — with links that take you straight to the main website.",

  "article.title": "Latest Guides & Resources",
  "article.subtitle": "In-depth, original guides to help you get the most out of the USFans Spreadsheet.",
  "article.cardTitle": "The Complete USFans Spreadsheet Guide 2026",
  "article.excerpt": "Learn what the USFans Spreadsheet is, how to use it, which categories to explore, and the safety and shipping basics to know before you buy.",
  "article.readMore": "Read the full guide",

  "why.title": "Why This Resource Exists",
  "why.body": "Finding reliable, up-to-date information about the USFans Spreadsheet can be time-consuming. This independent resource hub organizes the essentials — categories, guides and safety tips — so you can make informed decisions without hunting across scattered pages.",

  "cta.title": "Looking for the latest USFans resources?",
  "cta.body": "Explore the main website for additional information, updated links and current promotions.",
  "cta.button": "Visit Main Website",
};